export default __webpack_public_path__ + "static/media/logo-upload-placeholder.abb9ef8f.svg";